<template>
  <div class="table-card">
    <div class="card-title">Последние заявки</div>

    <table class="leads-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Дата создания</th>
          <th>Поля</th>
          <th>Уведомление</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item in visibleRequests"
          :key="item.id"
          class="tr__request"
        >
          <td>{{ item.id }}</td>
          <td>{{ formatDateTime(item.dt_created) }}</td>
          <td>
            <p class="td__p">
              <span v-html="getKeys(item)" />
            </p>
          </td>
          <td class="td__html-modal" @click="showHtmlModal(item)">
            <button>
              Просмотр
              <Icon class="show-html__svg" name="folder-eye" size="20" />
            </button>
          </td>
        </tr>

        <tr v-if="!requests || requests.length === 0">
          <td colspan="4" class="muted">Нет заявок</td>
        </tr>
      </tbody>
    </table>

    <!-- load more button (manual) -->
    <div v-if="enableLoadMore && visibleCount < requests.length" class="load-more">
      <button @click="loadMore" :disabled="loading">
        {{ loading ? 'Загрузка...' : 'Загрузить ещё' }}
      </button>
    </div>

    <!-- sentinel for infinite loading -->
    <div v-if="infinite" ref="sentinel" class="sentinel" aria-hidden="true"></div>

    <Modal v-model="showHtml">
      <template #header>
        <h2 class="td-modal-header__h2">Отправленное уведомление</h2>
      </template>

      <div v-html="currentHtml" />

      <template #footer>
        <div class="modal-footer__left"></div>
        <button @click="showHtml = false">Закрыть</button>
      </template>
    </Modal>
  </div>
</template>

<script>
import { formatDate, formatDateTime, linkifyAndSanitize } from './utils/helpers';
import { formRequestMessage } from './utils/formRequestMessage';
import Modal from '@/components/UI/Modal/Modal.vue';

export default {
  name: 'RecentLeadsTable',
  components: { Modal },
  props: {
    requests: { type: Array, default: () => [] },
    currentRangeTitle: { type: String, default: '' },

    // number of items per page / slice (по-умолчанию 10)
    pageSize: { type: Number, default: 10 },

    // если true — показываем кнопку "Загрузить ещё" и по клику подгружаем следующую порцию
    enableLoadMore: { type: Boolean, default: false },

    // если true — включаем автоматическую подгрузку через IntersectionObserver
    infinite: { type: Boolean, default: false }
  },
  data() {
    return {
      untags: ['p', 'h1', 'h2', 'span'],
      untagsIndexes: [],
      currentHtml: null,
      showHtml: false,

      // сколько элементов сейчас видно
      visibleCount: this.pageSize,
      loading: false,

      // observer для infinite
      observer: null
    };
  },
  computed: {
    // массив, который используется в шаблоне
    visibleRequests() {
      // если включена механика загрузки — показываем первые visibleCount
      // иначе показываем slice от 0 до pageSize (по-умолчанию)
      return (this.requests || []).slice(0, this.visibleCount);
    }
  },
  watch: {
    // если данные обновились — сбрасываем видимую длину на pageSize
    requests() {
      this.resetVisible();
    },
    pageSize(newVal) {
      // если pageSize изменился — скорректируем видимую длину
      this.visibleCount = newVal;
    }
  },
  methods: {
    formatDate,
    formatDateTime,

    getKeys(item) {
      const copy_model_value = [...(item.model_value || [])];
      const copy_user_value = [...(item.user_value || [])];
      const text = formRequestMessage({ modal_list: copy_model_value, user_value: copy_user_value });

      return linkifyAndSanitize(text);
    },

    showHtmlModal(item) {
      this.currentHtml = item.html;
      this.showHtml = true;
    },

    closeHtmlModal() {
      this.currentHtml = null;
      this.showHtml = false;
    },

    resetVisible() {
      this.visibleCount = this.pageSize;
    },

    loadMore() {
      if (this.loading) return;
      if (this.visibleCount >= (this.requests || []).length) return;

      this.loading = true;
      // имитируем асинхронную загрузку — если у вас реальный API, здесь можно сделать fetch
      setTimeout(() => {
        this.visibleCount = Math.min(this.visibleCount + this.pageSize, this.requests.length);
        this.loading = false;
      }, 250);
    },

    // вызывается наблюдателем при достижении sentinel
    handleIntersect(entries) {
      const entry = entries[0];
      if (entry && entry.isIntersecting) {
        if (this.visibleCount < (this.requests || []).length) {
          this.loadMore();
        }
      }
    }
  },
  mounted() {
    // если включен infinite — инициализируем IntersectionObserver
    if (this.infinite && typeof IntersectionObserver !== 'undefined') {
      this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
        root: null,
        rootMargin: '200px',
        threshold: 0.1
      });

      this.$nextTick(() => {
        const sentinel = this.$refs.sentinel;
        if (sentinel) this.observer.observe(sentinel);
      });
    }
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
};
</script>

<style scoped>
.table-card {
  background: var(--blue-3);
  padding: 1rem;
  border-radius: 0.5rem;
  margin-top: 0rem;
}
.leads-table {
  width: 100%;
  border-collapse: collapse;
}
.leads-table th {
  text-align: left;
  padding: 0.5rem;
  color: #64748b;
}
.leads-table td {
  padding: 0.5rem;
  border-top: 0.1rem solid rgba(15, 23, 42, 0.04);
}
.muted {
  color: #64748b;
  padding: 1rem;
}
.tr__request {
  border-bottom: 0.15rem solid var(--grey-1);
}
.tr:hover {
  background: #fff;
}
.td__p {
  text-align: left;
}
.show-html__svg {
}
.td-modal-header__h2 {
  text-align: left;
  font-size: 1.5rem;
}
.load-more {
  margin-top: 0.75rem;
  display: flex;
  justify-content: center;
}
.load-more button {
  padding: 0.5rem 1rem;
  border-radius: 0.375rem;
  border: none;
  background: var(--blue-6);
  color: white;
  cursor: pointer;
}
.sentinel {
  height: 1px;
}
</style>